/**
 * Widget to display a simple message next to some sort of element (tooltip).
 * 
 * Calling:
 * $('element').fieldAlertWidget({
 * 		// Options
 * });
 * 
 * See the wrapper functions at the bottom of this file for more information
 */
(function($){
	// Global Types
	var fieldAlertClasses = {
		normal: 'fieldAlert-regular',
		info: 'fieldAlert-info',
		help: 'fieldAlert-help',
		warning: 'fieldAlert-warning',
		error: 'fieldAlert-error'
	};
		
	/* ALERT MANAGER */
	$.widget('ui.alerts', {
		options: {
			haltBuild: false, // Used to prevent the qtip from rendering untl set to false again
			// Any valid qtip option can be added at this section
			qtip: {
				position: {
					my: 'bottom left',
					at: 'top right',
					adjust: {
						method: 'flip'
					},					
					viewport: $(window)
				},
				hide: {
					event: 'unfocus mouseleave',
					fixed: false,
					delay: 0
				},
				show: {
					event: 'focus mouseover',
					solo: false,
					delay: 140
				}
			},
			event: false,
            addClasses: true,
            autoShow: true
		},
						
		_create: function(){
			// Build the elements
			this._getParent();
			this.me = this.element;
			this._buildDataObj();
			
			// Set the default
			if(this.parent.is('[activehelp]')){
				this.add('help', {
					id: 'default',
					message: this.parent.attr('activehelp')
				}, false);
			}
			
			this.element.addClass('alert_d');
		},
		
		/**
		 * Because different elements can be called with this, figure out what element to use
		 */
		_getParent: function(){
			if(this.element.is('.select_d')){
				// Selectbox
				this.target = this.element.selectBox();
				this.target.selectBox('get');
				this.parent = this.element;
			}
			else if(this.element.is('.ui-inline-edit-target')){
			    // Inline Edit
			    this.target = this.element.data('inlineEdit').placeholder;
			    this.parent = this.element;
			}
			else {
				this.parent = this.target = this.element;
			}
			
			this.target.data('sk_alerts_parentals', this.parent);
		},
				
		_buildMessage: function(){
			var msgParts = [];
			if(this.me.data('sk_alerts').counts.error > 0){
				
				for(id in this.me.data('sk_alerts').store.error){
					if(id == null || typeof this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.error[id]] != 'object') continue;
											
					msgParts.push(this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.error[id]].message);
				}
				
				this.mode = 'error';
			}
			else if(this.me.data('sk_alerts').counts.warning > 0){
				for(id in this.me.data('sk_alerts').store.warning){
					if(id == null || typeof this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.warning[id]] != 'object') continue;
					
					msgParts.push(this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.warning[id]].message);
				}
				
				this.mode = 'warning';
			}
			else if(this.me.data('sk_alerts').counts.info > 0){
				for(id in this.me.data('sk_alerts').store.info){
					if(id == null || typeof this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.info[id]] != 'object') continue;
					
					msgParts.push(this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.info[id]].message);
				}
				
				this.mode = 'info';
			}
			else if(this.me.data('sk_alerts').counts.help > 0){
				for(id in this.me.data('sk_alerts').store.help){
					if(id == null || typeof this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.help[id]] != 'object') continue;
					
					msgParts.push(this.me.data('sk_alerts').links[this.me.data('sk_alerts').store.help[id]].message);
				}
				
				this.mode = 'help';
			}
			else {
				// Destroy the qtip
				this.mode = 'none';
			}
			var multipleParts = msgParts.length > 1;
			if(this.mode == 'error'){
				if(multipleParts){
					this.message = 'Errors: <ul><li>' + msgParts.join('</li><li>') + '</li></ul>';
				}else{
					this.message = 'Error: ' + msgParts[0];
				}
			}else if(this.mode == 'warning'){
				if(multipleParts){
					this.message = 'Warnings: <ul><li>' + msgParts.join('</li><li>') + '</li></ul>';
				}else{
					this.message = 'Warning: ' + msgParts[0];
				}
			}else{
				if(multipleParts){
					this.message = '<ul><li>' + msgParts.join('</li><li>') + '</li></ul>';
				}else{
					this.message = msgParts[0];
				}
			}
		},
		
		_rebuild: function(){
			if(this.mode == 'none'){
				if(this.target.is('.qtip_d')){
					this.target.qtip('destroy');
					this.target.removeClass('qtip_d');
				}
			}
			else {
				if(this.target.is('.qtip_d')){
					this.target.qtip('option', 'content.text', this.message);
					this.target.qtip('option', 'style.classes', 'ui-tooltip-rounded ui-tooltip-shadow ' + this._getClass());	
				}
				else {
					this._buildQTip();
					this.target.qtip('option', 'content.text', this.message);
					this.target.qtip('option', 'style.classes', 'ui-tooltip-rounded ui-tooltip-shadow ' + this._getClass());
				}
			}			
			this._rejigClasses();
		},
				
		_qtipOptions: {
			
		},
				
		_buildQTip: function(){
			if(this.options.haltBuild) return false;
			
			this.target.bind('focus.infoelm', function(){
				$(this).addClass('isFocused');
			});
			this.target.bind('blur.infoelm', function(){
				$(this).removeClass('isFocused');
				$(this).qtip('hide');
			});
			
			// Handle the options merging
			var qtipOpts = $.extend(true, {
				id: $(this).attr('id'),
				content:'Default Message',
				events: {
					hide: function(event, api){
						// If the element has focus, mouseout will not hide the qtip
						if(api.elements.target.is('.isFocused') && typeof event.originalEvent != 'undefined' && event.originalEvent != null && (event.originalEvent.type == 'mouseleave')){						
							event.preventDefault();
						}
					},
					show: function(event, api){
						// If this is a "help" element AND if active is set to "disabled", then don't show this qtip
//						if($(this).hasClass(fieldAlertClasses.help) && $('#help-management-dialog').hasClass('active-help-disabled'))
//							return false;
						
						if($(this).hasClass('disable-field-alert'))
							return false;
					},
					style: {
						classes: this._getClass(),
						tip: {
							border: 1
						}
					}
				}
			}, this.options.qtip);
			
			if(this.options.event !== false){
				this.target.qtip(qtipOpts, this.options.event);
			}
			else
				this.target.qtip(qtipOpts);
			
			
			
			this.target.addClass('qtip_d');
		},
		
		/**
		 * Get the style class
		 */
		_getClass: function(){
			switch(this.mode){
				case 'error':
				case 'warning':
				case 'info':
				case 'help':
					return fieldAlertClasses[this.mode];
					break;
										
				default:
					return fieldAlertClasses.normal;
					break;
			}
		},
		
		_removeInputClasses: function(){
			for(classKey in fieldAlertClasses){
				this.target.removeClass(fieldAlertClasses[classKey] + '-input');
			}
		},
		
		_rejigClasses: function(){
            if(this.options.addClasses) {
                this._removeInputClasses();
                if(!this.target.is('.button')){
                    this.target.addClass(this._getClass() + '-input');
                }
            }
		},
		
		_buildDataObj: function(){
			this.me.data('sk_alerts', {
				counts: {
					error: 0,
					warning: 0,
					info: 0,
					help: 0
				},
				store: {
					error: [],
					warning: [],
					info: [],
					help: []
				},
				links: {
					
				}
			});
		},

		rebuild: function(){
			this._rebuild();
		},
		

		/**
		 * Add an alert to the element. If the alert is of the same type, then it will be branched together
		 * @param options
		 */
		add: function(type, options, hide){			
			if(typeof options != 'object')
				return false;
									
			if(typeof options.message == 'undefined' || typeof options.id == 'undefined')
				return false;
						
			// Firstly make sure this ID isn't in use
			if(typeof this.me.data('sk_alerts').links[options.id] == 'object' && this.me.data('sk_alerts').links[options.id] != null){
				this.me.data('sk_alerts').links[options.id].type = type;
				this.me.data('sk_alerts').links[options.id].message = options.message;
			}
			else {
				this.me.data('sk_alerts').counts[type]++;
				this.me.data('sk_alerts').links[options.id] = { pos: this.me.data('sk_alerts').counts[type], type:type, message: options.message };
				this.me.data('sk_alerts').store[type][this.me.data('sk_alerts').counts[type]] = options.id;
			}
									
			// Build the message
			this._buildMessage();
			this._rebuild();
			
			// If the parent element doesn't show up, we're not going to show the qtip
			if(!this.parent.is(':visible'))
				hide = false;
			
			/*if(type == 'help' && !$('#help-management-dialog').is('.active-help-enabled')){
				// If qtips aren't enabled, info elements can be built but not shown
				this.target.qtip('hide');
			} else */
			if(hide != false && this.options.autoShow === true){
				this.target.qtip('show');
			}
		},
		
		/**
		 * Remove an alert from the element.
		 * @param id
		 * @param success {Function} A function to be called when the item is removed successfully
		 * @returns {Boolean}
		 */
		remove: function(id, success){				
			if(typeof this.me.data('sk_alerts').links[id] != 'undefined'){
				var elm = this.me.data('sk_alerts').links[id];
				if(typeof elm != 'object' || elm == null) return false;
				
				this.me.data('sk_alerts').store[elm.type][elm.pos] = null;
				this.me.data('sk_alerts').links[id] = null;
				this.me.data('sk_alerts').counts[elm.type]--;
				
				if(typeof success == 'function')
					success();
			}
			
			this._buildMessage();
			
			if(this.mode == 'help')
				this.target.qtip('hide');
			
			this.target.promise().done(function(elm){
				$(this).data('sk_alerts_parentals').alerts('rebuild');
			});
		},
		
		/**
		 * Clear all the alerts of a specific type
		 * @param type
		 */
		clear: function(type){
			for(linkKey in this.me.data('sk_alerts').store[type]){
				var lK = this.me.data('sk_alerts').store[type][linkKey];
				if(lK && this.me.data('sk_alerts').links[lK].type == type){
					delete this.me.data('sk_alerts').links[lK];
				}
			}
			this.me.data('sk_alerts').store[type] = [];
			this.me.data('sk_alerts').counts[type] = 0;
			this.target.removeClass(fieldAlertClasses[type] + '-input');
			
			this._buildMessage();

			if(this.mode == 'help')
				this.target.qtip('hide');
			
			this.target.promise().done(function(elm){
				$(this).data('sk_alerts_parentals').alerts('rebuild');
			});
		},
		
		/**
		 * Remove all alerts, except HELP
		 */
		clearAll: function(){
			this.clear('error');
			this.clear('warning');
			this.clear('info');
		},
		
		/**
		 * @return array of ids
		 */
		getAllIds: function(){
			var r = [];
			for(linkKey in this.me.data('sk_alerts').links){
				r.push(linkKey);
			}
			return r;
		},
		
		/**
		 * Get the currently active message
		 * @returns {String}
		 */
		get: function(){
			this._buildMessage();
			return this.message;
		},
		
		/**
		 * Show the qtip
		 * @param bool set force to true to show the qtip regardless if the parent is hidden or not
		 */
		show: function(force){
			if(this.parent.is(':visible') || force == true)
				this.target.qtip('show');
		},
		
		/**
		 * Hide the qtip
		 */
		hide: function(){
			this.target.qtip('hide');
		},
		
		/**
		 * Manually override the active class (will break stuff if not careful)
		 * @param mode
		 */
		overrideMode: function(mode){
			this.mode = mode;
			this._rebuild();
		},
		
		/**
		 * Restart a halt build
		 */
		startBuild: function(){
			this.options.haltBuild = false;
			this._rebuild();
			this.show();
		}
	});
	
})(jQuery);